<template>
  <div class="wrapper">
    <!-- data Table -->
    <div v-if="showPage">
      <CRow>
        <CCol col="12" xl="12">
          <CCard class="p-0">
            <CCardHeader
              class="
                d-flex
                justify-content-between
                align-items-center
                bg-secondary
              "
            >
              <h5 class="text-light m-0 p-0">کاربران</h5>
              <!-- <CRow class="col-sm-7 col-md-5 col-lg-3"> -->
                <CButton
                  color="light"
                  @click="
                    addModal = true;
                    modalTitle = 'افزودن کاربر';
                    modalButtonSubmit = 'ثبت';
                    GetOrganizationalStructureTree();
                    restoreDefault();
                    requiredPass= true;
                  "
                  class="mr-1"
                >
                  <CIcon name="cil-plus" /> افزودن
                </CButton>

                <!-- <CButton
                  color="warning"
                  @click="reportPage('userList')"
                  class="mr-1 col"
                >
                  <CIcon name="cil-print" /> گزارش
                </CButton> -->
              <!-- </CRow> -->
            </CCardHeader>
            <CCardBody>
              <div id="userapp">
                <!-- <link
                  href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
                  rel="stylesheet"
                  integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
                  crossorigin="anonymous"
                /> -->
                <main>
                  <data-table
                    v-bind="parametersTable"
                    @actionTriggered="handleAction"
                  />
                </main>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>

    <!-- create and edit user modal -->
    <CModal :title="modalTitle" :show.sync="addModal" size="xl"  :close-on-backdrop="false" >
      <CForm class="needs-validation" novalidate>
        <CAlert color="warning" closeButton :show.sync="alert">
          {{ alertText }}
        </CAlert>
        <h5 class="text-primary mb-3">اطلاعات فردی</h5>
        <hr />

        <CRow>
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="نام و نام خانوادگی"
            v-model="userInfo.firstAndLastName"
            required
            :value="userInfo.firstAndLastName"
          />
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="نام پدر"
            v-model="userInfo.fatherName"
            :value="userInfo.fatherName"
          />
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="کدملی"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            type="number"
            maxlength="10"
            required
            v-model="userInfo.codeMeli"
            :value="userInfo.codeMeli"
          />

          <div role="group" class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label for="uid-vvb5dt2i0jd" class="">تاریخ تولد </label
            ><date-picker
              class="col-sm-12 col-md-6 col-lg-4 p-0 m-0"
              v-model="userInfo.dateOfBirth"
              :value="userInfo.dateOfBirth"
              >تاریخ تولد</date-picker
            >
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label class="typo__label">جنسیت</label>
            <multiselect
              class="needs-validation"
              v-model="userInfo.gender"
              :options="genderList"
              :allowEmpty="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              :custom-label="nameWithLang"
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
            ></multiselect>
          </div>

          <CInput
            id="email"
            class="col-sm-12 col-md-6 col-lg-4"
            label="ایمیل"
            type="email"
            v-model="userInfo.email"
            :value="userInfo.email"
          />

         

          <div class="col-sm-12 col-md-6 col-lg-4">
            <label class="typo__label">ارسال گزارش روزانه</label>
            <multiselect
              class="needs-validation"
              v-model="userInfo.dailyReportSend"
              :options="dailyReportSendList"
              :searchable="true"
              :allow-empty="false"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
            ></multiselect>
          </div>

          <CInput
            id="mobileNumber"
            class="col-sm-12 col-md-6 col-lg-4"
            label="تلفن همراه"
            placeholder="مثال (4565***0912)"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            type="number"
            maxlength="11"
            required
            v-model="userInfo.phoneNumber"
            :value="userInfo.phoneNumber"
          />
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="تلفن ثابت"
            placeholder="مثال (5114****024)"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            type="number"
            maxlength="11"
            v-model="userInfo.telephoneNumber"
            :value="userInfo.telephoneNumber"
          />
        </CRow>

        <h5 class="text-primary mb-3 mt-4">اطلاعات حساب کاربری</h5>
        <hr />

        <CRow>
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="نام کاربری"
            required
            aria-autocomplete="off"
            v-model="userInfo.userName"
            :value="userInfo.userName"
          />

          <CInput
            id = "password"
            class="col-sm-12 col-md-6 col-lg-4"
            label="رمزعبور"
            type="password"
            :required="requiredPass"
            aria-autocomplete="off"
            v-model="userInfo.password"
            :value="userInfo.password"
          />

          <CRow
            align-vertical="center"
            class="col-sm-12 col-md-6 col-lg-4 m-0 p-0"
          >
            <CInputCheckbox
              label="وضعیت فعال بودن"
              class="mr-3 mb-2"
              :checked="userInfo.active"
              @change="userInfo.active = !userInfo.active"
            />
          </CRow>
        </CRow>

        <h5 class="text-primary mt-3">اطلاعات ساختار سازمانی</h5>
        <hr />

        <h6 class="text-secondary mb-3">انتخاب والد</h6>
        <v-jstree
          :data="structureList"
          show-checkbox
          allow-batch
          whole-row
          noDots
          @item-click="itemClick"
        ></v-jstree>

        <CRow>
          <div
            class="col-sm-12 col-md-6 col-lg-4 form-group"
            v-if="deviceList.length > 0"
          >
            <label class="typo__label">دستگاه ها</label>
            <multiselect
              class="needs-validation"
              v-model="userInfo.device"
              :options="deviceList"
              :allowEmpty="true"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              :custom-label="nameWithLang"
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
              :multiple="true"
              @input="updateSensorList()"
            ></multiselect>
          </div>
          <div
            class="col-sm-12 col-md-6 col-lg-4 form-group"
            v-if="sensorList.length > 0"
          >
            <label class="typo__label">سنسور ها</label>
            <multiselect
              class="needs-validation"
              v-model="userInfo.sensor"
              :options="sensorList"
              :allowEmpty="true"
              :searchable="true"
              :close-on-select="false"
              :show-labels="false"
              placeholder="انتخاب..."
              :custom-label="nameWithLang"
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
              :multiple="true"
            ></multiselect>
          </div>
        </CRow>

        <h5 class="text-primary mb-3 mt-4">اطلاعات تکمیلی</h5>
        <hr />

        <div class="col-sm-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label for="my-file">تصویر</label>
            <input
              type="file"
              accept=".jpg,.png,.jpeg"
              @change="previewImage"
              class="btn btn-secondary form-control-file"
              id="my-file"
            />

            <div class="border p-2 mt-3">
              <p>پیش نمایش:</p>
              <template v-if="preview">
                <img :src="preview" class="img-fluid" />
                <p class="mb-0">نام فایل: {{ image.name }}</p>
                <p class="mb-0">حجم: {{ image.size / 1024 }}KB</p>
              </template>
              <template v-else>
                <img :src="userInfo.userImage" class="img-fluid" />
              </template>
            </div>
          </div>
        </div>

        <CTextarea
          label="توضیحات"
          placeholder="Content..."
          rows="5"
          v-model="userInfo.description"
        />
      </CForm>

      <template #footer>
        <CButton
          v-if="modalButtonSubmit == 'تایید'"
          @click="addModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />تایید</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="
            addModal = false;
            alert = false;
          "
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template>
    </CModal>

    <!-- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف کاربر'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف کاربر'"
          @click="deleteUser"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>

    <!-- detected car modal -->
    <CModal
      :title="detectedCarModalTitle"
      :color="detectedCarModalColor"
      :show.sync="detectedCarModal"
    >
      <span v-if="detectedCarModalStatus == true">
        {{ detectedCarModalText }}
      </span>

      <div v-else>
        <CForm v-for="(info, i) in detectedCarModalInfo" :key="i">
          <CInput
            class="mb-0"
            placeholder="نام خودرو"
            :value="info.label"
            disabled
          >
            <template #prepend-content><CIcon name="cil-car-alt" /></template>
          </CInput>
          <CInput placeholder="پلاک" :value="info.value" disabled>
            <template #prepend-content
              ><CIcon name="cif-ir" style="display: block !important"
            /></template>
          </CInput>
        </CForm>
      </div>

      <template #footer>
        <CButton
          @click="detectedCarModal = false"
          :color="detectedCarModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{
            detectedCarModalButtonText
          }}</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<style lang="css">
.table-wrapper {
  height: 60vh !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import axios from "axios";
import { Values } from "../../../src/commonValues";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import $ from "jquery";
import Multiselect from "vue-multiselect";
import "core-js/stable";
import "regenerator-runtime/runtime";
import router from "../../router";
import VJstree from "vue-jstree-master"; //rtl
import { JsonHubProtocol } from "@aspnet/signalr";

export default {
  name: "Modals",
  data() {
    return {
      requiredPass:true,
      addModal: false,
      users: [],
      modalTitle: "",
      modalButtonSubmit: "",

      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      userId: "",

      carGroupList: [],
      carGroupvalue: [],

      detectedCarModal: false,
      detectedCarModalTitle: "",
      detectedCarModalText: "",
      detectedCarModalButtonText: "",
      detectedCarModalColor: "",
      detectedCarModalStatus: true,
      detectedCarModalInfo: [],

      preview: null,
      image: null,

      userInfo: {
        id: "",
        firstAndLastName: "",
        fatherName: "",
        dateOfBirth: "",
        userImage: "",
        codeMeli: "",
        gender: {
          value: "true",
          label: "مرد",
        },
        device: [],
        sensor: [],
        password: "",
        userName: "",
        email: "",
        phoneNumber: "",
        telephoneNumber: "",
        active: true,
        description: "",
        dailyReportSend: { label: "فعال", value: true },
      },

      dailyReportSendList: [
        { label: "فعال", value: true },
        { label: "غیرفعال", value: false },
      ],

      disableMultiselect: true,

      genderList: [
        {
          value: "true",
          label: "مرد",
        },
        {
          value: "false",
          label: "زن",
        },
      ],

      deviceList: [],

      sensorList: [],

      alert: false,
      alertText: "",

      showPage: true,

      structureList: [],
      selectedParent: "",
    };
  },

  components: {
    datePicker: VuePersianDatetimePicker,
    Multiselect,
    VJstree,
  },

  computed: {
    parametersTable() {
      return {
        data: this.users,
        actionMode: "single",
        columns: [
          {
            key: "rowNumber",
            title: "ردیف",
          },
          {
            key: "firstAndLastName",
            title: "نام",
          },
          {
            key: "activeName",
            title: "وضعیت",
          },
          {
            key: "email",
            title: "ایمیل",
          },
          {
            key: "phoneNumber",
            title: "شماره‌تلفن",
          },
          {
            key: "userName",
            title: "نام کاربری",
          },
        ],
        actions: ["view", "edit", "delete"], //, "assignCar"
      };
    },
  },

  mounted() {
    this.refreshTable();
  },

  methods: {
    //********************************************************************* get organiztion tree */
    GetOrganizationalStructureTree() {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "OrganizationalStructure/GetOrganizationalStructureTree",
          JSON.stringify(""),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.structureList = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* refresh datatable */
    refreshTable() {
      axios
        .get(Values.serverIp + "User/Users")
        .then((response) => {
          this.setUsers(response.data.data);
          console.log(response.data.data);
        })
        .catch((response) => {
          //console.log(response.response);
          //console.log("in catch");
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else if (response.response.status == 401) {
            //token has expired
            // modal unsuccessful edit change
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            delete axios.defaults.headers.common["Authorization"];
          }
        });
    },

    //********************************************************************* datatable view action */
    viewAction(data) {
      // disable alet
      this.alert = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(Values.serverIp + "User/GetUser", JSON.stringify(data.id), config)
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);

            this.addModal = true;
            this.modalTitle = "نمایش کاربر";
            this.modalButtonSubmit = "تایید";

            // clear all red borders
            $(".form-control").removeAttr("style");

            this.userInfo.id = response.data.data.id;
            this.userInfo.firstAndLastName =
              response.data.data.firstAndLastName;
            this.userInfo.fatherName = response.data.data.fatherName;
            this.userInfo.codeMeli = response.data.data.codeMeli;
            this.userInfo.dateOfBirth = response.data.data.dateOfBirth;
            this.userInfo.email = response.data.data.email;
            this.userInfo.phoneNumber = response.data.data.phoneNumber;
            this.userInfo.telephoneNumber = response.data.data.telephoneNumber;
            this.userInfo.userName = response.data.data.userName;
            this.userInfo.password = response.data.data.password;
            this.userInfo.description = response.data.data.description;
            this.selectedParent = response.data.data.organizationId;
            this.structureList = JSON.parse(response.data.tree);

             this.setDailayReportValue(
              response.data.data.sendEmailForDailyReport
            );

            //this.setDeviceList(response.data.data.deviceLevelList);
            this.getDeviceByOrganazionId(
              response.data.data.organizationId,
              1,
              response.data.data.deviceLevelList,
              response.data.data.sensorLevelList
            );
            //this.setSensorList(response.data.data.sensorLevelList);

            response.data.data.userImage == ""
              ? (this.userInfo.userImage = "")
              : this.convertUrlToBase64(
                  Values.serverIp + response.data.data.userImage
                );
            this.userInfo.active = response.data.data.active;
            this.setGenderValue(JSON.stringify(response.data.data.gender));

            // make all part to disabled
            $(".form-check, .form-control-file, .form-control").attr(
              "disabled",
              true
            );
            this.disableMultiselect = true;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              //(this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            //if (response.status != 200)
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable edit action */
    editAction(data) {
      // disable alet
      this.alert = false;
      this.requiredPass= false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "User/GetUserForUpdate",
          JSON.stringify(data.id),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);

            this.addModal = true;
            this.modalTitle = "ویرایش کاربر";
            this.modalButtonSubmit = "اعمال";

            // clear all red borders
            $(".form-control").removeAttr("style");

            // make all part to enabled
            $(".form-check, .form-control-file, .form-control").attr(
              "disabled",
              false
            );
            this.disableMultiselect = false;

            this.userInfo.id = response.data.data.id;
            this.userInfo.firstAndLastName =
              response.data.data.firstAndLastName;
            this.userInfo.fatherName = response.data.data.fatherName;
            this.userInfo.codeMeli = response.data.data.codeMeli;
            this.userInfo.dateOfBirth = response.data.data.dateOfBirth;
            this.userInfo.email = response.data.data.email;
            this.userInfo.phoneNumber = response.data.data.phoneNumber;
            this.userInfo.telephoneNumber = response.data.data.telephoneNumber;
            this.userInfo.userName = response.data.data.userName;
            this.userInfo.password = response.data.data.password;
            this.userInfo.description = response.data.data.description;
            this.selectedParent = response.data.data.organizationId;
            this.structureList = JSON.parse(response.data.tree);

             this.setDailayReportValue(
              response.data.data.sendEmailForDailyReport
            );

            this.getDeviceByOrganazionId(
              response.data.data.organizationId,
              1,
              response.data.data.deviceLevelList,
              response.data.data.sensorLevelList
            );

            response.data.data.userImage == ""
              ? (this.userInfo.userImage = "")
              : this.convertUrlToBase64(
                  Values.serverIp + response.data.data.userImage
                );
            this.userInfo.active = response.data.data.active;
            this.setGenderValue(JSON.stringify(response.data.data.gender));
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            //if (response.status != 200)
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable delete action */
    deleteAction(data) {
      (this.alertModal = true),
        (this.alertModalTitle = "حذف کاربر"),
        (this.alertModalText =
          "آیا از حذف کاربر " + data.firstAndLastName + " مطمئن هستید؟"),
        (this.alertModalColor = "warning"),
        (this.alertModalButtonText = "بله"),
        (this.userId = data.id);
    },

    //********************************************************************* datatable assign car action */
    assignCarAction(data) {
      //get assign car list from server
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "User/GetUserCars",
          JSON.stringify(data.id),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            // format registration plate
            this.detectedCarModalTitle =
              "ماشین های تخصیص داده شده به دستگاه : " + data.firstAndLastName;
            if (response.data.length == 0) {
              this.detectedCarModalStatus = true;
              this.detectedCarModalText =
                "خودرویی به این کاربر تخصیص داده نشده است.";
              this.detectedCarModalColor = "warning";
            } else {
              this.detectedCarModalStatus = false;

              // format regesteration plate
              for (var i = 0; i < response.data.length; i++) {
                if (response.data[i].value.substring(2, 3) != "ا")
                  response.data[i].value =
                    response.data[i].value.substring(0, 6) +
                    "ایران" +
                    response.data[i].value.substring(6);
                else
                  response.data[i].value =
                    response.data[i].value.substring(0, 8) +
                    "ایران" +
                    response.data[i].value.substring(8);
              }

              this.detectedCarModalInfo = response.data;
              this.detectedCarModalColor = "success";
            }
            this.detectedCarModalButtonText = "تایید";
            this.detectedCarModal = true;
          } else {
            // modal unsuccessful edit change
            (this.detectedCarModal = true),
              (this.detectedCarModalTitle = "خطایی رخ داده"),
              (this.detectedCarModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.detectedCarModalColor = "danger"),
              (this.detectedCarModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.detectedCarModal = true;
            this.detectedCarModalTitle = "خطایی رخ داده";
            this.detectedCarModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.detectedCarModalColor = "info"),
              (this.detectedCarModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* dataTable actions */
    handleAction(actionName, data) {
      // console.log(actionName);
      if (actionName == "view") {
        this.viewAction(data);
      } else if (actionName == "edit") {
        this.editAction(data);
      } else if (actionName == "delete") {
        this.deleteAction(data);
      } else if (actionName == "assignCar") {
        this.assignCarAction(data);
      }
    },

    //********************************************************************* set users*/
    setUsers: function (value) {
      this.users = value;
    },

    //********************************************************************* edit and create user */
    submitForm() {
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(".form-control").removeAttr("style");

      var mobileFormat =
        /^(09(0[1-2]|1[0-9]|3[0-9]|2[0-1])-?[0-9]{3}-?[0-9]{4})$/;
      var emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      var passwordFormat = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,100}$/;

      console.log(this.userInfo);
      console.log(this.selectedParent);
      var forms = document.querySelectorAll(".needs-validation");
      let formValid = true;
      let mobielValid = true;
      let emaillValid = true;
      let passwordValid = true;

      //console.log(forms[0][4].value.length);
      if (this.selectedParent != "") {
        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
            
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
           
          } else if (
            forms[0][i].id == "password" &&
            forms[0][i].required &&
            //forms[0][i].value == ""
            !forms[0][i].value.match(passwordFormat)
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            //formValid = false;
            passwordValid=false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].id == "mobileNumber" &&
            !forms[0][i].value.match(mobileFormat)
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            //formValid = false;
            mobielValid = false;
          } else if (
            forms[0][i].id == "email" &&
            !forms[0][i].value.match(emailFormat) &&
            !forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
            emaillValid = false;
          }
        }

        let api = "";
        if (this.modalButtonSubmit == "اعمال") api = "EditUser";
        else {
          api = "CreateUser";
          this.userInfo.id = "";
        }

        if (formValid == true && mobielValid == true && passwordValid == true) {
          let carGroup = [];
          //console.log(this.carGroupvalue.length);
          for (let j = 0; j < this.carGroupvalue.length; j = j + 1)
            carGroup.push(this.carGroupvalue[j].value);

          let tempDevice = [];
          for (var i = 0; i < this.userInfo.device.length; i++) {
            tempDevice.push(this.userInfo.device[i].value);
          }

          let tempSensor = [];
          for (var i = 0; i < this.userInfo.sensor.length; i++) {
            tempSensor.push(this.userInfo.sensor[i].value);
          }

          axios
            .post(Values.serverIp + "User/" + api, {
              id: this.userInfo.id,
              firstAndLastName: this.userInfo.firstAndLastName,
              fatherName: this.userInfo.fatherName,
              dateOfBirth: this.userInfo.dateOfBirth,
              userImage: this.userInfo.userImage,
              codeMeli: this.userInfo.codeMeli,
              gender: JSON.parse(this.userInfo.gender.value),
              password: this.userInfo.password,
              userName: this.userInfo.userName,
              email: this.userInfo.email,
              phoneNumber: this.userInfo.phoneNumber,
              telephoneNumber: this.userInfo.telephoneNumber,
              active: this.userInfo.active,
              description: this.userInfo.description,
              organizationId: this.selectedParent,
              deviceLevelList: tempDevice,
              sensorLevelList: tempSensor,
              sendEmailForDailyReport: this.userInfo.dailyReportSend.value,
            })
            .then((response) => {
              //console.log(response.data);
              if (response.status == 200 && response.data == "0") {
                this.addModal = false;
                this.alert = false;

                // modal successfuly
                (this.alertModal = true),
                  (this.alertModalTitle = "تغییرات"),
                  (this.alertModalText = "تغییرات با موفقیت انجام شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshTable();
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                if (response.data == "1") {
                  this.alertModalText =
                    "رمزعبور ضعیف است سعی کنید از ترکیبی از حروف کوچک و بزرگ و اعداد در رمزعبور استفاده کنید.";
                } else if (response.data == "2") {
                  this.alertModalText = "نام کاربری تکراری است.";
                } else if (response.data == "3") {
                  this.alertModalText = "کدملی قبلا ثبت شده است.";
                }
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((response) => {
              if (response.response.status == 403) {
                // do not have permission
                // modal unsuccessful edit change
                (this.alertModal = true),
                  //(this.showPage = false),
                  (this.alertModalTitle = "عدم مجوز"),
                  (this.alertModalText =
                    "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
                  (this.alertModalColor = "info"),
                  (this.alertModalButtonText = "تایید");
              }
            });
        } else {
          let tempMsg = "";
          if (formValid != true) {
            tempMsg = "لطفا تمامی موارد الزامی را وارد نمایید.";
          } else if (mobielValid != true) {
            tempMsg = "لطفا شماره تلفن همراه را بدرستی وارد نمایید.";
          }else if (passwordValid != true) {
            tempMsg = "رمزعبور باید حداقل 8 کاراکتر بوده و شامل حروف کوچک و بزرگ انگلیسی ، حداقل یک عدد و شامل کاراکترهای خاص (!@#$%^&*) باشد.";
          }
          // this.alert = true;
          // this.alertText = tempMsg;
          (this.alertModal = true),
            (this.alertModalTitle = "هشدار"),
            (this.alertModalText = tempMsg),
            (this.alertModalColor = "warning"),
            (this.alertModalButtonText = "تایید");
        }
      } else {
        // this.alert = true;
        // this.alertText = "لطفا والد را انتخاب نمایید.";
        (this.alertModal = true),
          (this.alertModalTitle = "هشدار"),
          (this.alertModalText = "لطفا والد را انتخاب نمایید."),
          (this.alertModalColor = "warning"),
          (this.alertModalButtonText = "تایید");
      }
    },

    //********************************************************************* delete user */
    deleteUser() {
      this.alertModal = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "User/DeleteUser",
          JSON.stringify(this.userId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.alertModal = true;
            this.alertModalTitle = "حذف";
            this.alertModalText = "حذف کاربر با موفقیت انجام شد";
            this.alertModalColor = "success";
            this.alertModalButtonText = "تایید";
            this.refreshTable();
          } else {
            console.log("in else"), (this.alertModal = true);
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              // (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },

    //********************************************************************* upload image */
    previewImage: function (event) {
      var input = event.target;
      let base64String = "";
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
          base64String =
            "data:image/jpg;base64," + reader.result.replace(/^.+,/, "");

          this.userInfo.userImage = base64String;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }

      console.log(this.preview);
    },

    //********************************************************************* set OfficeId */
    setOffice(val) {
      this.userInfo.officeId = val.target.value;
      // console.log(this.userInfo.officeId);
    },

    //********************************************************************* make form to default mode */
    restoreDefault() {
      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );
      this.disableMultiselect = false;

      // this.userInfo = [];
      (this.userInfo.id = ""),
        (this.userInfo.firstAndLastName = ""),
        (this.userInfo.fatherName = ""),
        (this.userInfo.codeMeli = ""),
        (this.userInfo.dateOfBirth = ""),
        (this.userInfo.gender = {
          value: "true",
          label: "مرد",
        }),
        (this.userInfo.email = ""),
        (this.userInfo.phoneNumber = ""),
        (this.userInfo.telephoneNumber = ""),
        (this.userInfo.userName = ""),
        (this.userInfo.password = ""),
        (this.userInfo.active = true),
        (this.userInfo.userImage = ""),
        (this.userInfo.description = ""),
        (this.selectedParent = "");
      (this.userInfo.device = []),
        (this.userInfo.sensor = []),
        (this.deviceList = []),
        (this.sensorList = []), // this.preview= null;
        (this.userInfo.dailyReportSend = { label: "فعال", value: true }),
        // this.image= null;

        // clear all red borders
        $(".form-control").removeAttr("style");

      // disable alet
      this.alert = false;
    },

    nameWithLang({ label, value }) {
      return `${label}`;
    },

    setGenderValue(data) {
      for (var i = 0; i < this.genderList.length; i++) {
        if (this.genderList[i].value == data) {
          this.userInfo.gender.label = this.genderList[i].label;
          this.userInfo.gender.value = this.genderList[i].value;
        }
      }
    },

    codeMeliValidation(code) {
      var L = code.length;

      if (L < 8 || parseInt(code, 10) == 0) console.log("false");
      code = ("0000" + code).substr(L + 4 - 10);
      if (parseInt(code.substr(3, 6), 10) == 0) console.log("false");
      var c = parseInt(code.substr(9, 1), 10);
      var s = 0;
      for (var i = 0; i < 9; i++)
        s += parseInt(code.substr(i, 1), 10) * (10 - i);
      s = s % 11;
      console.log((s < 2 && c == s) || (s >= 2 && c == 11 - s));
      // console.log("true");
    },

    // url to base64 converter
    convertUrlToBase64(imgSrc) {
      const getBase64FromUrl = async (url) => {
        const data = await fetch(imgSrc);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function () {
            const base64data = reader.result;
            resolve(base64data);
          };
        });
      };

      getBase64FromUrl(imgSrc).then((e) => {
        e == "data:"
          ? (this.userInfo.userImage = "")
          : (this.userInfo.userImage = e);
        this.preview = null;
      });
    },

    //*********************** report page */
    reportPage(data) {
      //router.push({ name: "JointReport", params: { whichReport: data }});

      let routeData = this.$router.resolve({
        name: "JointReport",
        query: { whichReport: data },
      });
      window.open(routeData.href, "_blank");
    },
    //***************************************** set Car Group List */
    setCarGroupList(data) {
      this.carGroupList = data;
    },

    //****************************************************************** select parrent */
    itemClick(node) {
      this.selectedParent = node.model.id;
      console.log(this.selectedParent);
      this.getDeviceByOrganazionId(node.model.id, 0);
    },

    //***************************************************************** getDeviceByOrganazionId */
    getDeviceByOrganazionId(data, read, selectedDevice, selectedSensor) {
      this.deviceList = [];
      this.userInfo.device = [];
      this.sensorList = [];
      this.userInfo.sensor = [];
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "UserDeviceAccessPermission/GetDeviceLevelSelectList",
          JSON.stringify(data),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.deviceList = response.data;
            if (read == 1) {
              for (var i = 0; i < this.deviceList.length; i++) {
                for (var j = 0; j < selectedDevice.length; j++) {
                  if (selectedDevice[j] == this.deviceList[i].value)
                    this.userInfo.device.push(this.deviceList[i]);
                }
              }

              this.updateSensorList(1, selectedSensor);
            }
          }
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              // (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },

    // ************************************************************** updata Sensor List
    updateSensorList(read, selectedSensor) {
      if (this.userInfo.device.length > 0) {
        this.sensorList = [];
        this.userInfo.sensor = [];
        let temp = [];
        for (var i = 0; i < this.userInfo.device.length; i++) {
          temp.push(this.userInfo.device[i].value);
        }

        axios
          .post(
            Values.serverIp +
              "UserDeviceAccessPermission/GetSensorLevelSelectList",
            {
              organizationId: this.selectedParent,
              deviceIds: temp,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              this.sensorList = response.data;
              if (read == 1) {
                for (var i = 0; i < this.sensorList.length; i++) {
                  for (var j = 0; j < selectedSensor.length; j++) {
                    if (selectedSensor[j] == this.sensorList[i].value)
                      this.userInfo.sensor.push(this.sensorList[i]);
                  }
                }
              }
            }
          })
          .catch((response) => {
            //console.log("in catch");
            if (response.response.status == 403) {
              // do not have permission
              // modal unsuccessful edit change
              (this.alertModal = true),
                // (this.showPage = false),
                (this.alertModalTitle = "عدم مجوز"),
                (this.alertModalText =
                  "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
                (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            } else {
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
              this.alertModalColor = "danger";
              this.alertModalButtonText = "تایید";
            }
          });
      } else {
        this.sensorList = [];
        this.userInfo.sensor = [];
      }
    },

    // *************************************************************** set device list
    setSensorList(data) {},

     //********************************************************************* set daily  report Value */
    setDailayReportValue(data) {
      for (var i = 0; i < this.dailyReportSendList.length; i++) {
        if (this.dailyReportSendList[i].value == data) {
          this.userInfo.dailyReportSend.label = this.dailyReportSendList[i].label;
         this.userInfo.dailyReportSend.value = this.dailyReportSendList[i].value;
        }
      }
    },
  },
};
</script>
